export const getFirstRow = (page: number, limit: number) => {
  return (page - 1) * limit;
};

export const getFakeValues = (dataKey: string, limit: number) => {
  return Array.from({ length: limit as number }, (_, i) => ({
    [dataKey]: i,
  }));
};
